// ---------------------------------------------------------------------------
// Ordinea paginilor în meniu.
//
// Era scrisă de mână și în bară, și în footer — două liste care puteau ajunge
// în ordini diferite fără ca nimeni să observe. Acum e una singură: se schimbă
// aici și se schimbă în amândouă.
//
// Ordinea urmează drumul vizitatorului: cine suntem, ce facem, cum ne scrii.
// Întrebările frecvente stau la capăt, ca sprijin pentru cine mai are nevoie
// de un răspuns înainte să se hotărască — nu între serviciu și contact.
// ---------------------------------------------------------------------------
const navItems = [
  { key: 'nav.home', path: '/' },
  { key: 'nav.about', path: '/about' },
  { key: 'nav.services', path: '/services' },
  { key: 'nav.contact', path: '/contact' },
  { key: 'nav.faq', path: '/faq' },
];

export default navItems;
